<template>
  <div class="publicMain">
    <div v-if="dataList.length > 0">
      <div class="item" v-for="(item, index) in dataList" :key="index" @click="getInfo">
        <div class="name">{{ item.gsmc }}</div>
        <div class="info">
          <div class="box-time">
            <div class="time">发布时间:{{ item.gsfqsj }}</div>
          </div>

          <div class="VoteType">使用公示</div>
        </div>
      </div>
    </div>
    <div v-else>
      <nodata></nodata>
    </div>
  </div>
</template>
<script>
import nodata from '../components/noData.vue'
import api from '@/api/public.js'
export default {
  props: {
    active: {
      type: Number,
      default: undefined
    }
  },
  components: { nodata },
  data() {
    return {
      dataList: [
        // {
        //     title: "紫云府5幢3单元电梯维修的验收投票公示",
        //     time: "2022-07-18"
        //   },

      ]
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        gslx: this.active,
        openId: sessionStorage.getItem('openId'),
        wyqyId: 0
      }
      api.publicList(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data
          this.dataList.forEach(item => {
            item.gsfqsj = item.gsfqsj.slice(0, 10)
          })
        } else {
          this.$toast.fail({
            message: '操作异常',
          })
        }

      }).catch(err => {

        this.$toast.fail({
          message: err,
        })
      })
    },
    getInfo(item) {
      if (this.active == '2') {
        // this.$router.push({ path: '/useDetail', query: { item, active: this.active } })
        location.href = '/useDetail' + '?id=' + item.id + '&active=' + this.active + item

      } else if (this.active == '3') {
        // this.$router.push({ path: '/votepublic', query: { item, active: this.active } })
        location.href = '/publicVote' + '?id=' + item.id + '&active=' + this.active + item
      }
      else {
        // this.$router.push({ path: '/publicDetail', query: { item, active: this.active } })
        location.href = '/publicDetail' + '?id=' + item.id + '&active=' + this.active + item
      }
    },
  },
  created() { },
  watch: {
    active: {
      handler(nval) {
      }
    }
  },
  beforeDestroy() {
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  width: 100%;
  height: 100%;
  overflow-x: auto;

  .item {
    margin-top: 20px;
    width: 100%;
    height: 102px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 16px;

    .name {
      width: 303px;
      height: 24px;
      font-size: 16px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222120;
      line-height: 24px;
    }

    .info {
      display: flex;

      .box-time {
        // flex: 60%;
        margin-top: 15px;
        margin-right: 15px;
        width: 153px;
        height: 30px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        text-align: center;

        .time {
          margin: auto;
          width: 133px;
          height: 24px;
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999998;
          line-height: 30px;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
      }

      .VoteType {
        margin-top: 15px;
        font-size: 13px;
        text-align: center;
        color: #00c797;
        width: 66px;
        height: 30px;
        line-height: 30px;
        background: rgba(0, 199, 151, 0.05);
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #00c797;
      }
    }
  }
}

.voteBottom {
  padding: 0 16px;
  margin-top: 20px;

  button {
    padding: 0 17px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ff6c1a;
    color: #fff;
    border-radius: 30px;
    float: right;
    border: none;
    font-size: 13px;
  }

  .VoteType {
    display: inline-block;
    font-size: 13px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 3px;
  }
}
</style>
